/*
 * @Descripttion: 评测周期设置表 接口
 * @version: 1.0
 * @Author: Erik Zhang
 * @Date: 2021-05-02
 * @LastEditors: Erik Zhang
 * @LastEditTime: 2021-05-02
 */

import http from '@/utils/kq/http'

const veStuPeriodApi = {
  //添加接口
  add(data){
    return http.post(http.service.stu+'veStuPeriod/add',data)
  },
  //删除接口
  delete(ids){
    return http.delete(http.service.stu+'veStuPeriod/deleteBatch?ids='+ids)
  },
  //修改接口
  update(data){
    return http.put(http.service.stu+'veStuPeriod/edit',data)
  },
  //分页查询接口
  page(pageData){
    return http.post(http.service.stu+'veStuPeriod/page',pageData)
  },
  //查询单个数据接口
  get(id){
    return http.get(http.service.stu+'veStuPeriod/queryById',{id:id})
  },
  //更新状态
  updateStatus(data){
    return http.post(http.service.stu+'veStuPeriod/updateStatus',data)
  },

};
export default veStuPeriodApi;
